import React from 'react';
import OneClickApplicationModuleView from './OneClickApplicationModuleView';
import ApprovalDecisionModuleView from './ApprovalDecisionModuleView';
import { useOneCickApplication } from './hooks/oneClickApplication.hook';
import PageLoadingMask from 'components/masks/PageLoadingMask';

const OneClickApplicationModuleController = props => {
  const {
    modulePosition,
    eventHandler,
    pageName,
    userInfo,
    history,
    partnersCustomTrackingMeta,
  } = props;

  const {
    oneClickApplicationconfig,
    postCustomerInfoToPreApprovalOneClick,
    showEditModal,
    onChangeEditModal,
    addressForm,
    ssnForm,
    employmentStatus,
    employmentStatusError,
    workPhone,
    workPhoneError,
    totalAnnualIncome,
    totalAnnualIncomeError,
    monthlyRent,
    monthlyRentError,
    bankAccountType,
    bankAccountTypeError,
    residence,
    residenceError,
    totalBalanceOfAccounts,
    totalBalanceOfAccountsError,
    ifOffered,
    ifOfferedError,
    isUsCitizen,
    isUsCitizenError,
    country,
    countryError,
    motherMaidenName,
    motherMaidenNameError,
    isCheckedTerms,
    isCheckedTermsError,
    showApprovalDecisionView,
    approvalDecision,
    isLoadingForm,
    personalInfo,
    setPersonalInfo,
    oneClickApplicationOffer,
    onMouseClickDetails,
    onClickGoToDashboard,
    onClickPricingAndTerms,
    onClickPrivacyPoliciy,
    onClickBankDisclaimers,
    onClickBankSecurity,
    setState,
    ssnError,
    onChangeTotalAnnualIncome,
    onChangeMonthlyRent,
    onChangeMotherMaidenName,
    phoneNumberStateList,
    quantityUserPhones,
    setQuantityUserPhones,
  } = useOneCickApplication({
    modulePosition,
    eventHandler,
    pageName,
    userInfo,
    history,
    partnersCustomTrackingMeta,
  });

  const loading =
    props.globalLoadingFlag || !oneClickApplicationOffer || isLoadingForm;

  if (loading) {
    return (
      <PageLoadingMask
        description={
          isLoadingForm ? 'Validating your information...' : 'Loading...'
        }
      />
    );
  } else if (showApprovalDecisionView) {
    return (
      <ApprovalDecisionModuleView
        oneClickApplicationOffer={oneClickApplicationOffer}
        approvalDecision={approvalDecision}
        onClickGoToDashboard={onClickGoToDashboard}
        decisionMap={oneClickApplicationconfig?.decisionMap}
        {...props}
      />
    );
  } else {
    return (
      <>
        <OneClickApplicationModuleView
          config={props.config}
          eventHandler={props.eventHandler}
          user={props.userInfo}
          numberOfActions={props.numberOfActions}
          showEditModal={showEditModal}
          onChangeEditModal={onChangeEditModal}
          addressForm={addressForm}
          ssnForm={ssnForm}
          postCustomerInfoToPreApprovalOneClick={
            postCustomerInfoToPreApprovalOneClick
          }
          workPhone={workPhone}
          workPhoneError={workPhoneError}
          totalAnnualIncome={totalAnnualIncome}
          totalAnnualIncomeError={totalAnnualIncomeError}
          residence={residence}
          residenceError={residenceError}
          totalBalanceOfAccounts={totalBalanceOfAccounts}
          totalBalanceOfAccountsError={totalBalanceOfAccountsError}
          ifOffered={ifOffered}
          ifOfferedError={ifOfferedError}
          isUsCitizen={isUsCitizen}
          isUsCitizenError={isUsCitizenError}
          employmentStatus={employmentStatus}
          employmentStatusError={employmentStatusError}
          monthlyRent={monthlyRent}
          monthlyRentError={monthlyRentError}
          bankAccountType={bankAccountType}
          bankAccountTypeError={bankAccountTypeError}
          country={country}
          countryError={countryError}
          motherMaidenName={motherMaidenName}
          motherMaidenNameError={motherMaidenNameError}
          isCheckedTerms={isCheckedTerms}
          isCheckedTermsError={isCheckedTermsError}
          personalInfo={personalInfo}
          setPersonalInfo={setPersonalInfo}
          oneClickApplicationOffer={oneClickApplicationOffer}
          onMouseClickDetails={onMouseClickDetails}
          onClickGoToDashboard={onClickGoToDashboard}
          onClickPricingAndTerms={onClickPricingAndTerms}
          onClickPrivacyPoliciy={onClickPrivacyPoliciy}
          onClickBankDisclaimers={onClickBankDisclaimers}
          onChangeTotalAnnualIncome={onChangeTotalAnnualIncome}
          onChangeMonthlyRent={onChangeMonthlyRent}
          onChangeMotherMaidenName={onChangeMotherMaidenName}
          onClickBankSecurity={onClickBankSecurity}
          setState={setState}
          oneClickApplicationconfig={oneClickApplicationconfig}
          ssnError={ssnError}
          phoneNumberStateList={phoneNumberStateList}
          quantityUserPhones={quantityUserPhones}
          setQuantityUserPhones={setQuantityUserPhones}
          {...props}
        />
      </>
    );
  }
};

export default OneClickApplicationModuleController;
